<script lang="ts">
  import { reverse } from 'lodash-es';

	import { goto } from '$app/navigation';
  import { createEventDispatcher } from 'svelte';

  import Tag from '$lib/components/common/tagging/Tag.svelte';
  import Media from '$lib/components/common/media/Media.svelte';
	

  import { me } from '$stores/user.store';
  import { PostsCore } from '$src/utils/postsCore.util';

  import type { GlobalSearchResult, thumbnail } from 'garden-common';

  const dispatch = createEventDispatcher<{ hover: never; close: never }>();

  export let data: GlobalSearchResult;

  interface Common {
    title: string;
    thumbnailUrl: thumbnail | null;
    type: string;
  }

  function dataToCommon(data: GlobalSearchResult): Common {
    if (data.type === 'post') {
      return {
        title: data.title,
        thumbnailUrl: data?.media[0]?.thumbnails[0],
        type: 'Post'
      };
    }

    if (data.type === 'user') {
      return {
        title: data.name,
        thumbnailUrl: data.profileImage,
        type: 'User'
      };
    }

    if (data.type === 'gallery') {
      return {
        title: data.title,
        thumbnailUrl: data.coverImageUrl,
        type: 'Gallery'
      };
    }
  }

  $: commonData = dataToCommon(data);

  let displayedTags: string[] = null;

	$: if (data && data.type === 'post' && data?.subcategories.length > 2) {
		displayedTags = [
			data?.category,
			...data?.subcategories,
			'+' + (data?.subcategories.length - 2).toString()
		];
	} else if (data.type === 'post') {
		displayedTags = [data?.category, ...data?.subcategories] || [];
	}

	function onClick() {
		if (data.type === 'user') {
			goto('/profile/' + data.userName);
			dispatch('close');
		} else if (data.type === 'post') {
			const core = new PostsCore($me, data as any, []);
			core.onFullPost();
			dispatch('close');
		} else if (data.type === 'gallery') {
			goto('/gallery/' + data.title);
			dispatch('close');
		}
	}
</script>

{#if commonData}
	<button
		class="flex hover:bg-garden-grey-50 py-[14px] px-[15px] items-center cursor-pointer focus:bg-gray-100 text-left w-full"
		on:click={onClick}
		on:keypress={onClick}
		on:mouseenter={() => dispatch('hover')}
		on:focus={() => dispatch('hover')}
	>
		<div
			class="bg-gray-100 overflow-hidden aspect-square w-[48px]"
			class:rounded-full={data.type === 'user'}
			class:rounded-[4px]={data.type !== 'user'}
		>
			{#if commonData.thumbnailUrl && typeof commonData.thumbnailUrl === 'string'}
				<Media src={commonData.thumbnailUrl} alt="" class="w-full h-full object-cover" />
			{:else if data.type == 'user'}
				<Media
					src={`https://api.dicebear.com/6.x/thumbs/svg?backgroundColor=B5F1D4&shapeColor=074D2B&seed=${commonData.title}`}
					alt=""
					class="w-full h-full object-cover"
				/>
			{/if}
		</div>

		<div class="ml-[8px] flex items-center w-full">
			<div>
				<div class="text-blueish-grey-800 font-medium font-switzer mb-[2px]">{commonData?.title}</div>
				<div>
					{#if data.type === 'user'}
						<span class="font-switzer text-sm text-[#6E7B8B]">@{data.userName}</span>
					{/if}

					{#if data.type === 'post'}
						<div class="flex gap-[4px]">
							
							{#if data.wasItem}
								<Tag label={'Classic'} rounded selectable={false} sm />
							{/if}
							{#each displayedTags as category}
								{#if category}
									<Tag label={category} rounded selectable={false} sm />
								{/if}
							{/each}
						</div>
					{/if}

					{#if data.type === 'gallery'}
						<span class="font-switzer font-medium text-sm text-grey-transparency-dark-56 flex items-center">
							{data.posts.length} posts &bull; {data.talents.length} talents &bull;

							<!-- Profile images of gallery collaborators -->
							<div class="inline-flex flex-row-reverse">
								{#each reverse(data.talents?.map(i => i.profileImage) || []) as profileImgUrl}
									<div class="w-[12px] overflow-visible">
										<div
										class="aspect-square bg-gray-100 rounded-full overflow-hidden border-[2px] border-white w-max"
										>
											<img src={profileImgUrl} alt="" class="w-[18px]" />
										</div>
									</div>
								{/each}
							</div>
						</span>
					{/if}
        		</div>
      		</div>

      		<div class="ml-auto text-color-gray-400 text-sm">{commonData.type}</div>
    	</div>
  	</button>
{/if}
